import React from 'react';
import { Box, Typography, Alert, Button, Paper } from '@mui/material';
import { Map, Warning, Settings } from '@mui/icons-material';

const MapFallback = ({ error, onRetry }) => {
  const isBillingError = error?.includes('BillingNotEnabledMapError') || error?.includes('billing');
  
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        p: 4,
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
      }}
    >
      <Map sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      
      <Typography variant="h5" gutterBottom color="text.primary">
        Map Temporarily Unavailable
      </Typography>
      
      {isBillingError ? (
        <Alert severity="warning" sx={{ mb: 3, maxWidth: 600 }}>
          <Typography variant="subtitle2" gutterBottom>
            Google Maps Billing Required
          </Typography>
          <Typography variant="body2">
            To enable maps functionality, please set up Google Maps API billing in your Google Cloud Console.
            The application will continue to work with all other features.
          </Typography>
        </Alert>
      ) : (
        <Alert severity="info" sx={{ mb: 3, maxWidth: 600 }}>
          <Typography variant="body2">
            Unable to load map at this time. Please check your internet connection and try again.
          </Typography>
        </Alert>
      )}

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        {onRetry && (
          <Button 
            variant="outlined" 
            onClick={onRetry}
            startIcon={<Settings />}
          >
            Retry Loading Map
          </Button>
        )}
        
        <Button 
          variant="contained" 
          href="https://console.cloud.google.com/apis/credentials"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<Settings />}
        >
          Configure Google Maps API
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
        All other BinBuddy features remain fully functional
      </Typography>
    </Paper>
  );
};

export default MapFallback;
